import * as StorageService from "../services/StorageService";
import {LOCALSTORAGE_ITEMS} from "./Constants";
import {FormattedMessage, FormattedNumber, IntlProvider} from "react-intl";
import * as AccountService from "../services/AccountService";
import * as CampaignService from "../services/CampaignService";
import {EventBus} from "./EventBus";
import React from "react";
import {APP_VERSION} from "../config/ClientConfig";


export const removeUserInfoFromStorage = () => {
    StorageService.removeItem(LOCALSTORAGE_ITEMS.USER_INFO);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.USER_TYPE);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.USER_EMAIL);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.CONTINUE_AS_GUEST);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.RESERVATION_INFO);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.ORDER_ID);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.CARD_DETAILS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.PREVIOUS_TRANSACTION_ID);
    // StorageService.removeItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN);
    // StorageService.removeItem(LOCALSTORAGE_ITEMS.CURRENT_CART);
    // StorageService.removeItem(LOCALSTORAGE_ITEMS.PRODUCT_DETAILS);
}
export const getCookie = (name) => {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].split("=");
        if (cookie[0] === name) {
            return cookie[1];
        }
    }
    return "";
}

export const detectBrowser = () => {
    const userAgent = navigator.userAgent;

    const browsers = [
        { name: "Chrome", regex: /Chrome\// },
        { name: "Safari", regex: /Safari\/.*Version\// },
        { name: "Samsung Browser", regex: /SamsungBrowser\// },
        { name: "Edge", regex: /Edg\// },
        { name: "Firefox", regex: /Firefox\// },
        { name: "Opera", regex: /OPR\// }
    ];


    const isSupported = browsers.some(browser => browser.regex.test(userAgent));


    const isBrave = userAgent.includes("Brave/") || (navigator.brave && navigator.brave.isBrave);

    const isIOSSafari = /iPhone|iPad|iPod/i.test(userAgent) && /Safari/i.test(userAgent) && !/Chrome/i.test(userAgent);

    let isStorageBlocked = false;
    try {
        localStorage.setItem('test', 'test');
        localStorage.removeItem('test');
    } catch (e) {
        isStorageBlocked = true;
    }


    let areCookiesBlocked = false;
    try {
        document.cookie = "testCookie=test; max-age=60; path=/";
        if (!document.cookie.includes("testCookie=test")) {
            areCookiesBlocked = true;
        }
        document.cookie = "testCookie=; max-age=0; path=/";
    } catch (e) {
        areCookiesBlocked = true;
    }

    if (isBrave) {
        console.log("Brave browser detected!");
    } else if (isStorageBlocked) {
        console.log("Storage (localStorage/sessionStorage) is blocked.");
    } else if (areCookiesBlocked) {
        console.log("Cookies are blocked.");
    } else if (!isSupported) {
        console.log("Some functionalities may not work with your current browser");
    } else {
        console.log("Supported browser detected");
    }


    if (!localStorage.getItem("UNSUPPORTED_BROWSER_ALERT_SHOWN") && (isBrave || isStorageBlocked || areCookiesBlocked) && !isIOSSafari) {
        let message = "Some functionalities may not work with your current browser due to privacy features like ad-blocking, storage blocking, or cookies blocking.";
        alert(message);


        localStorage.setItem("UNSUPPORTED_BROWSER_ALERT_SHOWN", "true");
    }
}





export const onUseAppInsteadOfWeb = () => {
    const shopName = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME);
    const userTable = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE);


    const navigateToApp = () => {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
            window.location.href = "https://play.google.com/store/apps/details?id=ro.gebs.zonizbeacon&referrer=utm_source%3Dzoniz%26utm_medium%3Dcpc%26utm_term%3D"+encodeURIComponent(shopName)+"%26utm_content%3D"+encodeURIComponent(userTable);
        }
        else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            window.location.href = 'https://apps.apple.com/ro/app/zoniz/id847332221';
        }else{
            window.location.href = 'https://www.zoniz.com/download';
        }
    }

    if(!StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID)) {
        AccountService.deleteAccount().then(r => {
            StorageService.removeItem(LOCALSTORAGE_ITEMS.USER_EMAIL);
            navigateToApp();
        });
    }else{
        navigateToApp();
    }
}

export const findMobileOperatingSystemAndGetLink = () => {
    const shopName = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME);
    const userTable = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE);
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
        return "https://play.google.com/store/apps/details?id=ro.gebs.zonizbeacon&referrer=utm_source%3Dzoniz%26utm_medium%3Dcpc%26utm_term%3D"+encodeURIComponent(shopName)+"%26utm_content%3D"+encodeURIComponent(userTable);
        // return "https://play.google.com/store/apps/details?id=ro.gebs.zonizbeacon";
    }
    else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "https://apps.apple.com/ro/app/zoniz/id847332221";
    }else{
        return "https://www.zoniz.com/download";
    }

}

export const findMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
        return "android";
    }
    else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "ios";
    }else{
        return "android"; // used for showing browser img @ Open in App banner
    }
}

export const getCategoryName = (category) => {

    const browserLocale = StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)? StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE).slice(0,2):null; // first two characeters from eg: en-US
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)):null;
    const shopLocale = shopDetails? shopDetails.lang:null;
    if(shopLocale===null){
        return
    }
    if (shopLocale != browserLocale) {
        const merchantConfig = shopDetails.merchantConfig;
        const categoryIndex = merchantConfig.productTags.findIndex(e => e == category);
        const categoriesInt = merchantConfig.productTags_int;
        if(categoriesInt && categoriesInt.length > categoryIndex && categoriesInt[categoryIndex] != null && categoriesInt[categoryIndex] != "") {
            return categoriesInt[categoryIndex];
        }else return category;
    }else{
        return category;
    }
}

export const getProdName = (product) => {
    const browserLocale = StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE).slice(0,2); // first two characeters from eg: en-US
    const shopLocale = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).lang :null;

    const nameInt = product.name_int;
    if (nameInt && nameInt != null && nameInt!= "" && shopLocale != browserLocale) {
        return nameInt;
    }else{
        return product.name;
    }
}

export const getExtraProductName = (extra) => {
    const browserLocale = StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE).slice(0,2); // first two characeters from eg: en-US
    const shopLocale = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).lang

    const nameInt = extra.name_int;
    if (nameInt && nameInt != null && nameInt!= "" && shopLocale != browserLocale) {
        return nameInt;
    }else{
        return extra.name;
    }
}

export const getOrderCheckoutMsg = () => {
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const browserLocale = StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)? StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE).slice(0,2):null; // first two characeters from eg: en-US
    const shopLocale = shopDetails? shopDetails.lang:null;

    const orderCheckoutMsg_int = shopDetails.merchantConfig.orderCheckoutMsg_int;
    const orderCheckoutMsg = shopDetails.merchantConfig.orderCheckoutMsg;

    let finalCheckoutMsg;

    if (orderCheckoutMsg_int && orderCheckoutMsg_int != null && orderCheckoutMsg_int != "" && shopLocale != browserLocale) {
        finalCheckoutMsg = orderCheckoutMsg_int;
    } else {
        finalCheckoutMsg = orderCheckoutMsg || <FormattedMessage id="TheWaiterWillBringYouTheCheckShort"/>;
    }
    return finalCheckoutMsg;
}

export const getProdDesc = (product) => {

    const browserLocale = StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE).slice(0, 2); // first two characeters from eg: en-US
    const shopLocale = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).lang

    const descInt = product.desc_int;

    let finalProductDesc;

    if (descInt && descInt != null && descInt != "" && shopLocale != browserLocale) {
        finalProductDesc = descInt;
    } else {
        finalProductDesc = product.desc;
    }


    finalProductDesc = finalProductDesc.replaceAll("<", "&lt;");
    finalProductDesc = finalProductDesc.replaceAll(">", "&gt;");
    const index1 = finalProductDesc.indexOf("[link=\"");
    if (index1 >= 0) {
        const index2 = finalProductDesc.indexOf("\"", index1 + "[link=\"".length);
        if(index2 > 0) {
            const link = finalProductDesc.substring(index1 + "[link=\"".length, index2);
            if(link.startsWith("http")){
                const index3 = finalProductDesc.indexOf("text=\"", index2 + 1);
                if (index3 >= 0) {
                    const index4 = finalProductDesc.indexOf("\"", index3 + "text=\"".length);
                    if (index4 >= 0) {
                        const text = finalProductDesc.substring(index3 + "text=\"".length, index4);
                        const index5 = finalProductDesc.indexOf("]", index4);
                        finalProductDesc = finalProductDesc.substring(0, index1) + "<br/><a href='" + link + "'>" + text + "</a></br>" + finalProductDesc.substring(index5 + 1);
                    }
                }
            }
        }
    }

    return finalProductDesc;

}

export const getProdOptions = (product, index) => {
    const browserLocale = StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE).slice(0,2); // first two characeters from eg: en-US
    const shopLocale = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).lang

    const optionsInt = product.options_int;
    if (optionsInt && optionsInt != null && optionsInt.length > index && optionsInt[index]!= "" && shopLocale != browserLocale) {
        return optionsInt[index];
    }else{
        return product.options[index];
    }
}


export const getProdOptionsFromCart = (choice) => {
    const browserLocale = StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)? StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE).slice(0,2):null; // first two characeters from eg: en-US
    const shopLocale = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).lang : null;

    const optionInt = choice.option_int;
    if (optionInt && optionInt != null && optionInt!= "" && shopLocale != browserLocale) {
        return optionInt;
    }else{
        return choice.option;
    }
}



export const getProdExtrasFromCart = (choice, extraPidNotAvailable) => {
    const browserLocale = StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)? StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE).slice(0,2):null; // first two characeters from eg: en-US
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const shopLocale = shopDetails? shopDetails.lang : null;
    const currency = shopDetails ? shopDetails.currency : null;

    const extrasNames = [];
    const priceLocale = StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE);
    if(choice.extras && choice.extras.length > 0) {
        const sortedExtras = [...choice.extras].sort((a, b) => (b.isReqExtra || b.req ? 1 : 0) - (a.isReqExtra || a.req? 1 : 0));
        sortedExtras.forEach(extra => {
            const extraInt = extra.name_int;
            let finalName = "";
            if (extraInt && extraInt != null && extraInt != "" && shopLocale != browserLocale) {
                finalName = extraInt;
            } else {
                finalName = extra.name
            }
            extrasNames.push(
                <div key={extra.pid} className={extraPidNotAvailable && extraPidNotAvailable.includes(extra.pid)? "row danger" : "row"}>{extra.isReqExtra || extra.req ? <FormattedMessage id="Includes"/> : <FormattedMessage id="Extra"/>}: &nbsp;
                    {finalName}&nbsp;
                    <span className="prod-price">
                <IntlProvider
                    locale={priceLocale}>
                    <FormattedNumber
                        value={
                            extra.price / 100.0}
                        style="currency"
                        minimumFractionDigits={2}
                        maximumFractionDigits={2}
                        currency={currency}/>
                </IntlProvider>

                </span>
                </div>);
        });
    }

    return extrasNames;
}
export const getTotalProducts = (orderDetails) => {
    let totalProducts = 0;

    orderDetails?.forEach(product => {
        if (product.status !== "CANCELED") {
            totalProducts+=product.quantity;
        }else{
            totalProducts-=product.quantity;
        }
    })
    return totalProducts;
}

export const calculatePercentage = (partialValue, totalValue, numOfDigits) => {
    const discount = (100 * partialValue) / totalValue;
    return (Math.round(discount * 100) / 100).toFixed(numOfDigits);
}

export const findReturnable = (products) => {
    for (const product of products) {
        if(product.extras){
            for (const extra of product.extras) {
                if (extra.returnable) {
                    return true;
                }
            }
        }
    }
    return false;
}
export const calculatePercentageDiscount = (allOrderProducts) => {
    
    if(allOrderProducts.discount == 0) return 0;
    
    const basePrice = calculateSubtotalPrice(allOrderProducts);

    const products = allOrderProducts.products;
    let returnableTotalValue = 0;

    for (const product of products) {
        if(product.extras){
            for (const extra of product.extras) {
                if (extra.returnable) {
                    returnableTotalValue += extra.price;
                }
            }
        }
    }
    return Math.round(allOrderProducts.discount / (basePrice  - returnableTotalValue) * 100);
}

export const calculateSubtotalPrice = (allOrderProducts, withDiscount, withTips, withDeliveryFee) => {
    const orderPrice = allOrderProducts.price;
    const discount = allOrderProducts.discount?allOrderProducts.discount:0;
    const tips = allOrderProducts.tips?allOrderProducts.tips:0;
    const deliveryFee = allOrderProducts.deliveryFee?allOrderProducts.deliveryFee:0;

    let basePrice = orderPrice + (withDiscount?0:discount) - (withTips?0:tips) - (withDeliveryFee?0:deliveryFee);

    return basePrice;
}

export const renderProducts = (allOrderProducts) => {
    const currency = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).currency:null;
    const finalProductsArray = [];

    for (let i = 0; i < allOrderProducts?.products.length; i++) {
        let found = false;
        for (let j = 0; j < finalProductsArray.length; j++) {
            if (allOrderProducts?.products[i].pid === finalProductsArray[j].pid &&
                allOrderProducts?.products[i].status === finalProductsArray[j].status &&
                allOrderProducts?.products[i].option === finalProductsArray[j].option &&
                allOrderProducts?.products[i].msg === finalProductsArray[j].msg
            ) {
                finalProductsArray[j].quantity += allOrderProducts?.products[i].quantity
                found = true;
                break;
            }
        }
        if (!found) {
            finalProductsArray.push({
                ...allOrderProducts.products[i]
            })
        }
    }

    const renderResult = [];
    const renderProduct = (product, productIndex) =>
        <div key={productIndex} className="product">
            <div className="row">
                <span className="prod-qty">{product.quantity}<span className="times">&times;</span></span>
                <span className="prod-name">{getProdName(product)}</span>
                <span className="prod-price">&nbsp;
                    <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                        <FormattedNumber
                            value={product.price / 100}
                            style="currency"
                            minimumFractionDigits={2}
                            maximumFractionDigits={2}
                            currency={currency} />
                    </IntlProvider>
                </span>
            </div>
            <div className="choices row">
                {product.option?
                    <span>
                        {getProdOptionsFromCart(product)}
                        &nbsp;</span>
                    :null
                }
                {product.msg?
                    <span>{product.msg}&nbsp;</span>
                    :null
                }
            </div>
            <div className="choices row">
                {product.extras?
                    <>
                        {getProdExtrasFromCart(product)}
                    </>
                    :null
                }
            </div>
        </div>;
    const renderCanceledProduct = (product, productIndex) =>
        <div key={productIndex} className="product canceled">
            <div className="row">
                <div className="prod-name-and-qty">
                    <span className="prod-qty">{product.quantity}<span className="times">&times;</span></span>
                    <span className="prod-name">{getProdName(product)}</span>
                </div>
                <span className="prod-price">
                    <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                        <FormattedNumber
                            value={product.price / 100}
                            style="currency"
                            minimumFractionDigits={2}
                            maximumFractionDigits={2}
                            currency={currency} />
                    </IntlProvider>
                </span>
            </div>
            <div className="choices row">
                {product.option?
                    <span>
                        {getProdOptionsFromCart(product)}
                        &nbsp;</span>
                    :null
                }
                {product.msg?
                    <span>{product.msg}&nbsp;</span>
                    :null
                }
                <div className="choices row">
                    {product.extras?
                        <>
                            {getProdExtrasFromCart(product)}
                        </>
                        :null
                    }
                </div>
            </div>
        </div>;

    for (var i = 0; i < finalProductsArray.length; i++) {
        const finalProduct_i = finalProductsArray[i];
        if (finalProduct_i.status === "CANCELED") {

        } else if (finalProduct_i.status === "READY") {
        } else {
            for (var j = 0; j < finalProductsArray.length; j++) {
                if (finalProduct_i.pid === finalProductsArray[j].pid &&
                    finalProductsArray[j].status === "CANCELED" &&
                    finalProduct_i.option === finalProductsArray[j].option &&
                    finalProduct_i.msg === finalProductsArray[j].msg
                ) {
                    finalProduct_i.quantity -= finalProductsArray[j].quantity;
                }
            }
        }

        if (finalProduct_i.quantity > 0){
            if(finalProduct_i.status === "CANCELED") {
                renderResult.push(renderCanceledProduct(finalProduct_i, i));
            } else {
                renderResult.push(renderProduct(finalProduct_i, i));
            }
        }
    }

    return renderResult;
}



export const handleScrollPosition = () => {
    const scrollPosition = StorageService.getItem(LOCALSTORAGE_ITEMS.SCROLL_POSITION);
    if (scrollPosition) {
        setTimeout(() => {
            window.scrollTo({ top: scrollPosition, left: 0});
            StorageService.removeItem(LOCALSTORAGE_ITEMS.SCROLL_POSITION);
        }, 100);
    }
};
const isTimeIntervalOpen = (startOrder, endOrder, ti) => {
    const currentTime = toMinutes(new Date().getHours() + ":" + new Date().getMinutes());
    const openingTime = toMinutes(ti.openFrom, - startOrder);
    const closingTime = toMinutes(ti.openUntil, - endOrder);
    if (compareMinutes(closingTime, openingTime) === 1) {
        return (compareMinutes(openingTime, currentTime) === -1 || compareMinutes(openingTime, currentTime) === 0) &&
            (compareMinutes(closingTime, currentTime) === 1 || compareMinutes(closingTime, currentTime) === 0);
    }else if (compareMinutes(closingTime, openingTime) === -1) {
        return !(compareMinutes(openingTime, currentTime) === 1 && compareMinutes(closingTime, currentTime) === -1);
    }else {
        return true;
    }
};

const isTimeIntervalOpenForReservation = (ti) => {
    const currentTime = toMinutes(new Date().getHours() + ":" + new Date().getMinutes());
    const openingTime = toMinutes(ti.openFrom);
    const closingTime = toMinutes(ti.openUntil);

    if (compareMinutes(closingTime, openingTime) === 1) {
        return (compareMinutes(openingTime, currentTime) <= 0 && compareMinutes(closingTime, currentTime) >= 0);
    } else if (compareMinutes(closingTime, openingTime) === -1) {
        return !(compareMinutes(openingTime, currentTime) === 1 && compareMinutes(closingTime, currentTime) === -1);
    } else {
        return true;
    }
};

const isDayOfWeekScheduleOpenForReservation = (daySchedule) => {
    if (daySchedule?.isOpen) {
        if (daySchedule.daySchedule?.length) {
            return daySchedule.daySchedule.some(timeSlot => isTimeIntervalOpenForReservation(timeSlot));
        }
        return isTimeIntervalOpenForReservation({ openFrom: daySchedule.openFrom, openUntil: daySchedule.openUntil });
    }
    return false;
};

export const isReservationOpen = () => {
    const shopDetails = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS));

    if (!shopDetails?.merchantConfig?.weekReservationSchedule?.schedule ||
        shopDetails.merchantConfig.weekReservationSchedule.schedule.length === 0) {
        return false;
    }

    const dayOfWeek = new Date().getDay() === 0 ? 6 : new Date().getDay() - 1;
    const daySchedule = shopDetails.merchantConfig.weekReservationSchedule.schedule[dayOfWeek];

    return isDayOfWeekScheduleOpenForReservation(daySchedule);
};

const isDayOfWeekScheduleOpen = (dayOfWeekSchedule, startOrder, endOrder) => {
    if(dayOfWeekSchedule){
        if(dayOfWeekSchedule.isOpen) {
            if(dayOfWeekSchedule.daySchedule) {
                for (let i = 0; i < dayOfWeekSchedule.daySchedule.length; i++) {
                    if (isTimeIntervalOpen(startOrder,endOrder,dayOfWeekSchedule.daySchedule[i])) {
                        return true;
                    }
                }
                return false;
            }else {
                return isTimeIntervalOpen(startOrder,
                    endOrder,
                    {
                        openFrom: dayOfWeekSchedule.openFrom,
                        openUntil: dayOfWeekSchedule.openUntil
                    });
            }
        }else {
            return false;
        }
    }
    return false;
}

export const isShopOpen = () => {

    const shopDetails = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS));

    if (! !!shopDetails.merchantConfig.weekOpenSchedule ||
        ! !!shopDetails.merchantConfig.weekOpenSchedule.shopOpenSchedule ||
        ! !!shopDetails.merchantConfig.weekOpenSchedule.schedule ||
        shopDetails.merchantConfig.weekOpenSchedule.schedule.length === 0

    ) {
        return false;
    }

    const dayOfWeek = new Date().getDay() === 0 ? 6: new Date().getDay() -1; // because in Javascript Sunday is 0 and in the array from weekOpenSchedule Sunday is 6

    const dayOfWeekSchedule = shopDetails.merchantConfig.weekOpenSchedule?.schedule[dayOfWeek];
    return isDayOfWeekScheduleOpen(dayOfWeekSchedule,
        shopDetails.merchantConfig.weekOpenSchedule?.startOrder,
        shopDetails.merchantConfig.weekOpenSchedule?.endOrder);
}

export const isDeliveryOpen = () => {

    const shopDetails = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS));

    if (! !!shopDetails?.merchantConfig.weekDeliverySchedule ||
        ! !!shopDetails?.merchantConfig.weekDeliverySchedule.schedule ||
        shopDetails?.merchantConfig.weekDeliverySchedule.schedule.length === 0
    ) {
        return false;
    }

    const dayOfWeek = new Date().getDay() === 0 ? 6: new Date().getDay() -1; // because in Javascript Sunday is 0 and in the array from weekOpenSchedule Sunday is 6

    const dayOfWeekSchedule = shopDetails.merchantConfig.weekDeliverySchedule?.schedule[dayOfWeek];
    return isDayOfWeekScheduleOpen(dayOfWeekSchedule,
        shopDetails.merchantConfig.weekOpenSchedule?.startOrder,
        shopDetails.merchantConfig.weekOpenSchedule?.endOrder);
}

const toMinutes = (time, addedMinutes) => {

    let hoursMin = parseInt(time.substring(0,2))*60;
    if(addedMinutes) hoursMin = hoursMin + addedMinutes;
    let minutes = parseInt(time.substring(3,5));
    return hoursMin + minutes;
}
const compareMinutes = (t1, t2) => {
    if(t1 == t2){
        return 0;
    }else if(t1 < t2){
        return -1;
    }else {
        return 1;
    }
}

export const addMinutes = (date, minutes) => {
    return new Date(date.getTime() + minutes*60000);
}

export const resetTime = (day) => {
    day.setHours(0);
    day.setMinutes(0);
    day.setSeconds(0);
    day.setMilliseconds(0);

    return day;
}


export const getLastTwelveMonths = () => {
    let d = new Date();
    d.setMonth(d.getMonth() - 12);
    return d;
}

export const clearStorageItems = () => {
    StorageService.removeItem(LOCALSTORAGE_ITEMS.SUBORDERS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.ORDER_ID);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.GROUP_ORDER_ID);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.ALL_TAGS_AND_PRODUCTS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.PRODUCT_DETAILS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.CURRENT_CART);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.LOYALTY_PRODUCTS_POINTS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.ALL_CAMPAIGNS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.CALL_TS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.SHOP_NAME);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.USER_TABLE);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.PAYMENT_METHOD);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.HAS_BACK_BUTTON);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.ORDER_PLACE);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.PLAY_SOUND);
    StorageService.removeItem("loginInfo"); //used in campaigns from controllers

}


export const getAllCampaigns= async (shopName) => {
    const ts = StorageService.getItem(LOCALSTORAGE_ITEMS.CALL_TS);
    if (ts && new Date().getTime() - ts > 30 * 60 * 1000) {// 30 minute 30*60*1000
        StorageService.removeItem(LOCALSTORAGE_ITEMS.ALL_CAMPAIGNS);
    }

    if (StorageService.getItem(LOCALSTORAGE_ITEMS.ALL_CAMPAIGNS)) {
        return JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.ALL_CAMPAIGNS));
    }else{
        const allCampaignsResponse = await CampaignService.getAllCampaigns(shopName);
        if (allCampaignsResponse.ok) {
            const allCampaigns = allCampaignsResponse?.data;
            const correctOrderOnPage = ["products", "takeaway", "reservation"];
            let orderedAllCampaigns =[];


            const menuCampaigns = {};

            for(let j = 0; j < correctOrderOnPage.length; j++){
                menuCampaigns[correctOrderOnPage[j]] = [];
            }

            for(let i = 0; i < allCampaigns.length; i++){
                const campaign = allCampaigns[i];
                let menuFound = false;
                if(campaign.link && campaign.link.url){
                    for(let j=0;j < correctOrderOnPage.length;j++){
                        if(campaign.link.url.includes(correctOrderOnPage[j])){
                            menuCampaigns[correctOrderOnPage[j]].push(campaign);
                            menuFound = true;
                            break;
                        }
                    }
                }
                if(!menuFound){
                    orderedAllCampaigns.push(campaign);
                }
            }

            for(let j = correctOrderOnPage.length-1; j >= 0; j--){
                orderedAllCampaigns = menuCampaigns[correctOrderOnPage[j]].concat(orderedAllCampaigns);
            }

            if (orderedAllCampaigns) {
                StorageService.setItem(LOCALSTORAGE_ITEMS.ALL_CAMPAIGNS, JSON.stringify(orderedAllCampaigns));
                StorageService.setItem(LOCALSTORAGE_ITEMS.CALL_TS, new Date().getTime());
            }
            return allCampaigns;
        } else {
            EventBus.dispatch("genericErrorMsg");
            console.log("Error retrieving all campaigns");
            return [];
        }
    }
}

export function roundHalfEven(v) {
    return Math.round(v)&~(v*v%1==.25);
}

export const getProductInfoByPid = (data, pid) => {

    for (const category of data) {
        for (const product of category.products) {

            if (product.pid === pid) {

                return {
                    ...product,
                    extras: "x"
                };
            }
        }
    }
    return null;
}
export const getProductsOrderFromCart = (currentCart) => {
    if (! !!currentCart) {
        return;
    }
    return Object.keys(currentCart).flatMap((category, index) => {
        const categoryObject = currentCart[category];
        return Object.keys(categoryObject).flatMap((prodName, index) => {
            const product = categoryObject[prodName];
            return {
                ...product,
                category: category
            };
        });
    })
}

export const handleAppVersionUpdate = () => {
    if (StorageService.getItem(LOCALSTORAGE_ITEMS.APP_VERSION) !== APP_VERSION) {
        StorageService.setItem(LOCALSTORAGE_ITEMS.APP_VERSION, APP_VERSION);
        clearStorageItems();
    }
}

export const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

export const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};


export const refreshOnTabChange = () => {

    let shopName = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME);

    const onFocus = () => {
        if (shopName != StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME)) {
            console.log("RELOADING...");
            window.location.reload();
        }
    };
    window.addEventListener("focus", onFocus);
};

export const refreshOnTabChange2 =  () => {
    let shopName = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME);
    let hidden = null;
    let visibilityChange = null;
    if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
        hidden = 'hidden';
        visibilityChange = 'visibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
        hidden = 'msHidden';
        visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
        hidden = 'webkitHidden';
        visibilityChange = 'webkitvisibilitychange';
    }

    const handleVisibilityChange = () => {
        if (! !!document[hidden]) {
            if (shopName != StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME)) {
                console.log("Tab reload");
                window.location.reload();
                document.removeEventListener(visibilityChange, handleVisibilityChange);
            };
        }
    }

    document.addEventListener(visibilityChange, handleVisibilityChange);
};


